(function () {
  'use strict';

  function ensureBox() {
    var root = document.querySelector('[data-kk-notice]');
    if (root) return root;
    root = document.createElement('div');
    root.className = 'kk-notice';
    root.setAttribute('data-kk-notice', '');
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="kk-notice__backdrop" data-kk-notice-backdrop></div>' +
      '<div class="kk-notice__box" role="alertdialog" aria-modal="true">' +
      '<p class="kk-notice__text" data-kk-notice-text></p>' +
      '<button type="button" class="kk-notice__close" data-kk-notice-close>OK</button>' +
      '</div>';
    (document.body || document.documentElement).appendChild(root);
    return root;
  }

  function show(message) {
    var root = ensureBox();
    var text = root.querySelector('[data-kk-notice-text]');
    if (text) text.textContent = message || '';
    var cartLink = root.querySelector('[data-kk-notice-cart]');
    if (cartLink) cartLink.hidden = true;
    root.removeAttribute('hidden');
    root.classList.add('is-open');
    root.style.cssText =
      'display:flex;position:fixed;inset:0;z-index:2147483647;align-items:center;justify-content:center;padding:24px;';
    var close = root.querySelector('[data-kk-notice-close]');
    if (close) close.focus();
  }

  function hide() {
    var root = document.querySelector('[data-kk-notice]');
    if (!root) return;
    root.setAttribute('hidden', '');
    root.classList.remove('is-open');
    root.style.display = 'none';
  }

  window.KKNotice = { show: show, hide: hide };

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('[data-kk-notice-close], [data-kk-notice-backdrop]')) {
        event.preventDefault();
        hide();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide();
  });
})();
